const getTags = (action) => action.entities.tags;

export default function tagsReducer(state = {}, action) {
  switch (action.type) {
    case "TAGS_FETCHED":
      return { ...state, ...getTags(action) };
    default:
      return state;
  }
}
